// extracted by mini-css-extract-plugin
module.exports = {"filter":"WalletTransactionsFilter_filter__4kizG","fields":"WalletTransactionsFilter_fields__2Fg71","field":"WalletTransactionsFilter_field__2SWb5"};